import React, { useState, useEffect, useImperativeHandle, forwardRef } from "react";
//import FlexView from "react-flexview";
import DataGrid from "../../../../shared/Components/Grid";
import {exportGrid, initialColsSelector, onChangeColumns} from "../../../../shared/Components/Grid/functions";
import { getColumnDefs } from "./columnDefs";

export interface Props {
  data: any;
  ref: any;
  style?: any;
  menu: boolean;
  selector: boolean;
  informe: string;
  onSelected?(selected: any): any;
	onChange?(row: any): any;
  onMostrarOcultarClick?(idCentro: string, idPais: string, noMostrar: boolean): any;
  verBotonMostrarOcultar?: boolean;
  onSubirBajarClick?(idCentro: string, centroSubido: boolean): any;
  onOtroFormatoClick?(idCentro: string, idPais: string, noMostrar: boolean): any;
  onLabelBottomClick?(idPais: string, campo: string, labelBottom: boolean): any;
}

export const GridResultsScreen = forwardRef((props:Props, ref:any) => {

  
  const onSubirBajarNivelClick = (idCentro: string, centroSubido: boolean) => {
    onSubirBajarClick && onSubirBajarClick(idCentro, centroSubido);
  }

  const onVerOcultarClick = (idCentro: string, idPais: string, noMostrar: boolean) => {
    onMostrarOcultarClick && onMostrarOcultarClick(idCentro, idPais, noMostrar);
  }

  const onCentroOtroFormatoClick = (idCentro: string, idPais: string, noMostrar: boolean) => {
    onOtroFormatoClick && onOtroFormatoClick(idCentro, idPais, noMostrar);
  }

  const onLabelBottomButtonClick = (idPais: string, value: boolean, colName: string) => {
    onLabelBottomClick && onLabelBottomClick(idPais, colName, value);
    // console.log('idPais', idPais);
    // console.log('value', value);
    // console.log('colName', colName);
  }

  let { data, style, menu, selector, informe, onSelected, onChange, onMostrarOcultarClick, verBotonMostrarOcultar, onSubirBajarClick, onOtroFormatoClick, onLabelBottomClick} = props;
  let [columnDefs, setColumnDefs] = useState(getColumnDefs(informe, onVerOcultarClick, verBotonMostrarOcultar, onSubirBajarClick, onCentroOtroFormatoClick, onLabelBottomButtonClick));
  let [columnsState, SetColumnsState] = useState(selector?initialColsSelector(columnDefs):[])
  let [api, setApi] = useState(undefined)

  useEffect(()=>{
    setColumnDefs([]);
    // console.log('data GRID columndefs');
    setColumnDefs([...getColumnDefs(informe, onVerOcultarClick, verBotonMostrarOcultar, onSubirBajarNivelClick, onCentroOtroFormatoClick, onLabelBottomButtonClick)]);
    onRowSelection(api)
  },[data])

  useEffect(()=>{
    // console.log('change informe', informe);
  },[informe])


  const onSelection = (api: any, selected: any) => {
		onSelected && onSelected(selected);
  };

  const onRowValueChanged = (api: any, event: any) => {
		onChange && onChange(event.data);
  };
  
  const onHideColumn = (newColumns:[any]) =>{
    let newState = onChangeColumns(newColumns, columnDefs);
    SetColumnsState(newState)
  }

  const onRowSelection = (api:any) =>{
    let data = api && api.getSelectedNodes();
    let a = api && api.refreshCells();
    if(data)
    {
      data = data.filter((f:any) => f.isSelected()===true)
      onSelected && onSelected(data.map((d:any)=> d.data));
    }
  }

  useImperativeHandle(
    ref,
    () => ({
        onExport() {
            api && exportGrid({ fileName: "Data", api: api })
        }
     })
  )

  const updateApi = (api:any) =>{
    setApi(api)
  }
  // console.log('DataGrid data GRID', data);
    return (
      // <FlexView grow column>
        <DataGrid
        data={data}
        columnDefs={columnDefs}
        columnsState={columnsState}
        menu={menu}
        selector={selector}
        floatingFilter
        fileExportName="data"
        onHideColumn = {onHideColumn}
        onSelectionChanged={onSelection}
        onRowValueChanged={onRowValueChanged}
        updateApi={updateApi}
        />
      // </FlexView>
    );
});